<template>
  <div>
    <div class="ls_drawer_main_content">
      <Row class="mb-30">
        <Col span="24" :md="12" style="text-align: center">
          <img
            :src="image_url"
            style="width: 90%; max-height: 200px; max-width: 200px; color: red"
          />

        </Col>
        <Col span="24" :md="12">

          <h1 class="item_detail_header mb-15">{{ detail.name }}
            <Tag v-show="detail.deleted_date" color="error">Удален</Tag>
          </h1>

          <div class="color-grey fs-15 mb-15">
            <Row>
              <Col span="12">
                Тип:
              </Col>
              <Col span="12">
                {{ detail.type_display }}
              </Col>
            </Row>
            <Row>
              <Col span="12">
                Штрих-код:
              </Col>
              <Col span="12">
                {{ detail.barcode }}
              </Col>
            </Row>
            <Row>
              <Col span="12">
                Артикул:
              </Col>
              <Col span="12">
                {{ detail.sku }}
              </Col>
            </Row>
            <Row>
              <Col span="12">
                Код товара:
              </Col>
              <Col span="12">
                {{ detail.code }}
              </Col>
            </Row>
          </div>

        </Col>
      </Row>

      <!-- RECENT OPERATIONS -->
      <div class="d-flex justify-center mb-30 buttons-group">
        <RadioGroup v-model="info_operations_switch" type="button" class="d-flex">
          <Radio :label="info_operations_switch_labels[0]"></Radio>
          <Radio :label="info_operations_switch_labels[1]"></Radio>
        </RadioGroup>

        <div>
          <Dropdown>
            <Button type="primary">
              Действия
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">

              <router-link to="/pdocs/create?type=PURCHASE" class="card-container">
                <DropdownItem>
                  Закупка
                </DropdownItem>
              </router-link>

              <router-link to="/pdocs/changes_in/create" class="card-container">
                <DropdownItem>
                  Оприходование
                </DropdownItem>
              </router-link>

            </DropdownMenu>
          </Dropdown>
        </div>

      </div>

      <div v-if="info_operations_switch === info_operations_switch_labels[0]" class="color-grey fs-15">
        <Row>
          <Col span="10">
            Дата создания:
          </Col>
          <Col span="14">
            {{ formatDateTime(detail.created_date) }}
          </Col>
        </Row>
        <Row>
          <Col span="10">
            Категории:
          </Col>
          <Col span="14">
            {{ categories }}
          </Col>
        </Row>
        <Row>
          <Col span="10">
            Страна:
          </Col>
          <Col span="14">
            {{ detail.country_display }}
          </Col>
        </Row>
        <Row>
          <Col span="10">
            Срок годности:
          </Col>
          <Col span="14">
            {{ formatDateTime(detail.expiration_date) }}
          </Col>
        </Row>
        <Row>
          <Col span="10">
            Описание:
          </Col>
          <Col span="14">
            {{ detail.description }}
          </Col>
        </Row>
        <Divider v-if="detail.type !== TYPE_SERVICE" dashed="true"><h2>Цены</h2></Divider>
        <Divider v-if="detail.type === TYPE_SERVICE" dashed="true"><h2>Цена</h2></Divider>
        <Table
          :columns="prices_columns"
          :data="prices_data"
          style="margin-bottom: 40px;"
        ></Table>
        <Divider v-if="detail.type === TYPE_KIT">
          <h2>Состав комплекта</h2>
        </Divider>
        <Table
          v-if="detail.type === TYPE_KIT"
          :columns="kit_columns"
          :data="detail.kit"
          style="margin-bottom: 40px;"
        ></Table>
        <Divider v-if="detail.type === TYPE_PRODUCT" dashed="true"><h2>Склад</h2> </Divider>
        <Divider v-if="detail.type === TYPE_SERVICE || detail.type === TYPE_KIT" dashed="true"><h2>Цены по магазинам</h2> </Divider>
        <Table
          v-if="detail.type === TYPE_SERVICE || detail.type === TYPE_KIT || detail.type === TYPE_PRODUCT"
          :columns="prices_by_stores_columns"
          :data="prices_by_stores_data"
          style="margin-bottom: 40px;"
        ></Table>
      </div>

      <recentProductOrders
        v-else
        style="min-height: 20%; margin-top: 20px"
        filter_by="product"
        :filter_by_id="id"
      ></recentProductOrders>

    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" type="primary" @click="cancelAction()"><Icon type="md-close" /></Button>
      <Button style="margin-right: 8px" v-if="display_edit_button" type="info" @click="editAction()"><Icon type="md-create" /></Button>
      <Button v-if="display_delete_button" type="error" @click="removeModal = true" style="float: left"
        ><Icon type="md-trash"/>
      </Button>
    </div>


    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данный <span class="no-wrap">товар/услугу</span>?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteAction()">
          Удалить
        </Button>
      </Row>
    </Modal>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { BaseDetailData } from "../../base/base_detail_v2.js";
import { base_url, server_addr } from "../../http.js";
import recentProductOrders from "../../components/core/recentProductOrders";

let _app = BaseDetailData();

const TYPE_PRODUCT = "PRODUCT";
const TYPE_SERVICE = "SERVICE";
const TYPE_KIT = "KIT";

_app.data = function() {
  return {
    loading: true,
    detail_id: this.id,
    detail: {},

    info_operations_switch: "Информация",
    info_operations_switch_labels: ["Информация", "История движения"],

    stores: [],

      removeModal: false,
      removeId: null,
      footerHide: true,
  };
};
_app.methods.fetchItem = function() {
  this.loading = true;

  const url = `${this.base_view_url}${this.detail_id}/`;
  this.$http
    .get(url)
    .then(result => {
      this.detail = result.data;
      this.$emit("data_loaded", this.detail);
    })
    .finally(() => {
      this.loading = false;
    });
};
_app.components = {
  recentProductOrders,
};
_app.methods.editAction = function() {
  this.$router.push({
    /*name: this.item_type + "_edit",*/
    name: "catalog_edit",
    params: { id: this.id }
  });
};

_app.computed.TYPE_PRODUCT = function() {
  return TYPE_PRODUCT;
};
_app.computed.TYPE_SERVICE = function() {
  return TYPE_SERVICE;
};
_app.computed.TYPE_KIT = function() {
  return TYPE_KIT;
};

_app.computed.currency = function() {
  return this.$store.state.currency;
};
_app.computed.prices_columns = function() {
  let columns = [
    {
      title: "Розничная цена",
      // key: 'base_price',
      align: "center",
      render: (h, params) => {
        return h(
          "div",
          {},
          this.formatNumber(params.row.base_price) + " " + this.currency
        );
      }
    },
  ];
  if (this.detail.type !== TYPE_SERVICE) {
    let position = 0;

    columns.splice(position, 0, {
      title: "Цена закупки",
      // key: 'purchase',
      align: "center",
      render: (h, params) => {
        return h(
          "div",
          {},
          this.formatNumber(params.row.purchase) + " " + this.currency
        );
      }
    },
    {
      title: "Наценка",
      // key: 'markup_price',
      align: "center",
      render: (h, params) => {
        return h("div", {}, this.formatNumber(params.row.markup_price) + " %");
      }
    });

    columns.push({
      title: "Оптовая цена",
      // key: 'trade_price',
      align: "center",
      render: (h, params) => {
        return h(
          "div",
          {},
          this.formatNumber(params.row.trade_price) + " " + this.currency
        );
      }
    });
  }

  return columns;
};

_app.computed.kit_purchase = function() {
  let total_purchase = 0
  let kit = this.detail.kit.map(position=> ({purchase: parseFloat(position.purchase), amount: position.amount}))

  for (let item of kit) {
    total_purchase += item.purchase * item.amount
  }
  //console.log('kit', kit)
  //console.log('total_purchase', total_purchase)
  return total_purchase;
};

_app.computed.kit_markup_price = function() {
  let purchase = parseFloat(this.kit_purchase)
  let base_price = parseFloat(this.detail.base_price)
  let total_markup = ((base_price - purchase) / purchase * 100).toFixed(2)
  //console.log('base_price', base_price)
  //console.log('total_markup', total_markup)

  if (isFinite(total_markup) && total_markup >= 0) {
    return total_markup;
  } else {
    return 0;
  }
};

_app.computed.prices_data = function() {
  return [
    {
      purchase: this.detail.type !== TYPE_KIT ? this.detail.purchase : this.kit_purchase,
      base_price: this.detail.base_price,
      markup_price: this.detail.type !== TYPE_KIT ? this.detail.markup_price : this.kit_markup_price,
      trade_price: this.detail.trade_price
    }
  ];
};

_app.computed.kit_columns = function() {
  return [
    {
      title: "Наименование",
      // key: 'purchase',
      // align: 'center',
      render: (h, params) => {
        return h(
          "router-link",
          {
            props: {
              to: {
                name: "catalog_detail",
                params: { id: params.row.child_product }
              }
            }
          },
          params.row.child_product_name
        );
      }
    },
    {
      title: "Количество",
      key: "amount",
      align: "right"
      // render: (h, params) => {
      //   return h("div", {}, formatNumber(params.row.markup_price) + ' %');
      // }
    },
    {
      title: "Розничная цена",
      // key: 'base_price',
      align: "right",
      render: (h, params) => {
        return h(
          "div",
          {},
          this.formatNumber(params.row.base_price) + " " + this.currency
        );
      }
    },
    {
      title: "Оптовая цена",
      // key: 'trade_price',
      align: "right",
      render: (h, params) => {
        return h(
          "div",
          {},
          this.formatNumber(params.row.trade_price) + " " + this.currency
        );
      }
    }
  ];
};

_app.computed.prices_by_stores_columns = function() {
  //console.log('yep!')
  let name_column = {
    title: "Магазин",
    key: 'store_name',
  };
  if (this.display_store_link) {
    name_column =     {
      title: "Магазин",
      // key: 'purchase',
      // align: 'center',
      render: (h, params) => {
        return h(
          "router-link",
          {
            props: {
              to: {
                name: "store_detail",
                params: { id: params.row.store }
              }
            }
          },
          params.row.store_name
        );
      }
    };
  }
  let columns = [
    name_column,
    {
      title: "Розничная цена",
      // key: 'base_price',
      align: "right",
      render: (h, params) => {
        return h(
          "div",
          {},
          this.formatNumber(params.row.price) + " " + this.currency
        );
      }
    }
  ];
  if (this.detail.type !== TYPE_SERVICE) {
    let position = 2;
    let column = {
      title: "Оптовая цена",
      // key: 'trade_price',
      align: "right",
      render: (h, params) => {
        return h(
          "div",
          {},
          this.formatNumber(params.row.trade_price) + " " + this.currency
        );
      }
    };
    
    columns.splice(position, 0, column);

    if (this.detail.type !== TYPE_KIT) {
      columns.push(
      {
        title: "Остаток",
        key: "rest",
        align: "right",
        render: (h, params) => {
          return h("span", {}, this.formatNumber(params.row.rest) + ' ' +  this.detail.unit);
        }
      });
    }
  }
  //console.log('columns: ', columns)
  return columns;
};

_app.computed.prices_by_stores_data = function() {
  let data = [];
  let rests_obj = {};
  let prices_obj = {};

  if (this.detail.rest_by_stores.length > 0) {
    for (let item of this.detail.rest_by_stores) {
      rests_obj[item.store] = {
        value: item.value
      };
    }
  }

  if (this.detail.prices_by_stores.length > 0) {
    for (let item of this.detail.prices_by_stores) {
      prices_obj[item.store] = {
        value: item.value,
        trade_value: item.trade_value,
      };
    }
  }

  if (this.stores.length > 0) {
    for (let store of this.stores) {
      let price = prices_obj.hasOwnProperty(store.id) ? prices_obj[store.id].value : this.detail.base_price;
      let trade_price = prices_obj.hasOwnProperty(store.id) ? prices_obj[store.id].trade_value : this.detail.trade_price;
      let rest = rests_obj.hasOwnProperty(store.id) ? rests_obj[store.id].value : 0;

      data.push({
        store: store.id,
        store_name: store.name,
        price: price,
        trade_price: trade_price,
        rest: rest
      });
    }
  }
  //console.log('prices data: ', data)
  return data;
};

_app.computed.categories = function() {
  if ("categories_display" in this.detail) {
    return this.detail.categories_display.join(", ");
  } else {
    return "";
  }
};

_app.computed.image_url = function() {
  if (this.detail.image_url) {
    return server_addr + this.detail.image_url;
  } else {
    return "/static/img/no-image-icon-big.png";
    // return "/assets/no-image-placeholder.png"
  }
};

_app.computed.display_edit_button = function() {
  if ('can_update' in this.detail) {
    return (this.detail.can_update && (
      this.permissions.indexOf("catalog.product_update_all") !== -1 ||
      this.permissions.indexOf("catalog.product_update_owner") !== -1
    ));
  }
  return (
    this.permissions.indexOf("catalog.product_update_all") !== -1 ||
    this.permissions.indexOf("catalog.product_update_owner") !== -1
  );
};
_app.computed.display_delete_button = function() {
  if ('can_delete' in this.detail) {
    return (this.detail.can_delete && (
      this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
      this.permissions.indexOf("catalog.product_delete_owner") !== -1
    ));
  }
  return (
    this.permissions.indexOf("catalog.product_delete_all") !== -1 ||
    this.permissions.indexOf("catalog.product_delete_owner") !== -1
  );
};
_app.methods.getStores = function() {
  const url = base_url + "/options/stores/";
  this.$http
    .get(url)
    .then(result => {
      this.stores = result.data.results;
    })
};

_app.mounted = function(){
  this.getStores();
};

export default _app;
</script>

<style scoped>


   .buttons-group button.ivu-btn-primary {
      text-transform: uppercase;
      font-size: 14px;
    }

   @media screen and (max-width: 991px) {
     .buttons-group button.ivu-btn-primary {
       text-transform: none;
     }
   }

   @media screen and (max-width: 575px) {
     .buttons-group .ivu-radio-group-button .ivu-radio-wrapper:last-child {
       margin-right: 12px;
     }
     .buttons-group button.ivu-btn-primary {
       font-size: 13px;
     }
   }

   @media screen and (max-width: 575px) {
     .buttons-group {
       flex-direction: column;
       justify-content: flex-start;
     }
     .buttons-group .ivu-radio-group-button .ivu-radio-wrapper {
       margin-bottom: 12px;
     }
   }






</style>



// WEBPACK FOOTER //
// src/apps/catalog/catalogDetail.vue